import { ViewModel, View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { ServerConnection } from "src/server/serverConnection";
import { IMachineModel } from "./IMachineModel";
import { MachineModelEditorViewModel, MachineModelInserter, MachineModelUpdater } from "./machineModelEditor/machineModelEditor-viewModel";
import { MachineModelManipulationView } from "./machineModelManipulation-view";

export class MachineModelManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return 'تعریف مدل ماشین';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);

        this.isLoading = false;
        this.machineModels = ObservableArray.create<MachineModel>();
        this.dataLoader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);

        this.refresh();
    }
    GetDefaultView(): View<ViewModel> {
        return new MachineModelManipulationView();
    }
    public getTypeId(): string {
        return "VM-80D062F3-1B26-43B9-B495-E7CDFB4DAB48"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set machineModels(v: ObservableArray<MachineModel>) { this._machineModels = v; } public get machineModels(): ObservableArray<MachineModel> { return this._machineModels; } private _machineModels: ObservableArray<MachineModel>;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    async refresh() {
        await this.dataLoader.refresh();
    }

    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/MachineModelServices/ListAllMachineModels', {
                FilteringInformation: filteringInformation
            });
            this.machineModels.update(...result.MachineModels.map((x, i) => {
                let m = new MachineModel(this);
                m.index = ((result.PaginationInfo.CurrentPage - 1) * result.PaginationInfo.PageSize) + i + 1;
                m.id = x.Id;
                m.name = x.Name;
                m.code = x.Code;
                m.comment = x.Comment;
                m.machineTypeId = x.MachineTypeId;
                m.machineTypeName = x.MachineTypeName;
                m.machineTypeCode = x.MachineTypeCode;
                return m;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }

    async addNew() {
        let popup = new MachineModelEditorViewModel(this, new MachineModelInserter());
        let result = await this.showPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async edit(machineModel: IMachineModel) {
        let popup = new MachineModelEditorViewModel(this, new MachineModelUpdater());
        await machineModel.cloneTo(popup);
        let result = await this.requestShowingPopup(popup);
        if (result == 'done') {
            this.dataLoader.refresh();
        }
    }

    async remove(machineModel: MachineModel): Promise<void> {
        let isDeleted = await this.messageBoxDangerYesNo('آیا از حذف اطمینان دارید؟', 'حذف');
        if (isDeleted == 'yes') {
            try {
                this.isLoading = true;
                let result = await ServerConnection.callServer("/Complex/MachineModelServices/DeleteMachineModel", {
                    MachineModelId: machineModel.id,
                });
                if (result.IsSuccessful == true) {
                    await this.messageBoxConfirmSuccess("حذف با موفقیت انجام شد", "عملیات موفق");
                    this.dataLoader.refresh();
                } else {
                    if (result.Faults[0].Parameters.FaultId == 'D2BF392F-0EC9-4491-9DD3-FF7F3E096630') {
                        await this.messageBoxConfirmWarning("امکان حذف وجود ندارد", "خطا در عملیات");
                    }
                }
            } catch (ex) {
                await this.messageBoxConfirmWarning("خطا در عملیات حذف", "خطا در عملیات");
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }
}

export class MachineModel extends ViewModel implements IMachineModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: MachineModelManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
    }

    private _typedParent: MachineModelManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index; } private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment; } private _comment: string;
    public set machineTypeId(v: string) { this._machineTypeId = v; } public get machineTypeId(): string { return this._machineTypeId; } private _machineTypeId: string;
    public set machineTypeName(v: string) { this._machineTypeName = v; } public get machineTypeName(): string { return this._machineTypeName; } private _machineTypeName: string;
    public set machineTypeCode(v: string) { this._machineTypeCode = v; } public get machineTypeCode(): string { return this._machineTypeCode; } private _machineTypeCode: string;

    setMachineTypeId(id: string) {
        this.machineTypeId = id;
    }

    getMachineTypeId(): string {
        return this.machineTypeId;
    }

    async cloneTo(machineModel: IMachineModel) {
        machineModel.id = this.id;
        machineModel.name = this.name;
        machineModel.code = this.code;
        machineModel.comment = this.comment;
        machineModel.setMachineTypeId(this.machineTypeId);
    }

    async edit() {
        this._typedParent.edit(this);
    }

    async remove(): Promise<void> {
        this._typedParent.remove(this);
    }
}
